import { gql } from '@apollo/client'

import { PAYMENT_METHODS_FRAGMENT } from '../fragments/paymentMethodFragments'

const PAYMENT_METHODS_QUERY = gql`
  ${PAYMENT_METHODS_FRAGMENT}
  query PaymentMethodsQuery($archivedType: ArchivedType, $num: Int!) {
    user {
      id
      dogs {
        id
        name
      }
      shippingCountryCode
      preferredLanguage
      subscription {
        id
        status
        activePaymentMethodType
        deliveriesReceived
        nextNBoxes(num: $num) {
          id
          isNextEditableBox
          isFreeBox
        }
      }
      ...PaymentMethodsFragment
    }
  }
`

export { PAYMENT_METHODS_QUERY }
